<!-- TODO: address the style tag, tailwind classnames are not working here for some reason -->
<script lang="ts" module>
	export interface InputLabelProps {
		for?: string;
		name?: string;
		children?: import('svelte').Snippet;
		description?: import('svelte').Snippet;
		class?: string;
		onclick?: () => void;
		variant?: TxtVariant;
		required?: boolean | undefined;
		optional?: boolean | undefined;
		dark?: boolean | undefined;
		dataCy: string;
		classes?: {
			description?: string;
			wrapper?: string;
			container?: string;
		};
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { Txt, type TxtVariant } from '../Txt';
	import { Mandatory } from './Mandatory';

	let {
		variant = 'label3',
		required = undefined,
		optional = undefined,
		dark = false,
		dataCy,
		onclick,
		classes = {},
		children,
		description,
		...rest
	}: InputLabelProps = $props();
</script>

<div class={twMerge('flex w-full items-end justify-between gap-4', classes?.container)}>
	<Txt
		{onclick}
		dataCy={`${dataCy}-label`}
		component="label"
		{variant}
		{...rest}
		class={twMerge('flex cursor-pointer select-none items-center min-h-[20px]', rest.class)}
	>
		<span
			class={twMerge(
				classNames(dark ? 'text-gray-0' : '', { 'flex items-center gap-2': !required }),
				classes.wrapper
			)}
			>{@render children?.()}{#if required}<Mandatory />{/if}</span
		>
	</Txt>
	{#if optional}
		<Txt variant="label4" class="text-gray-500">Optional</Txt>
	{/if}
</div>

{#if description}
	<Txt
		{onclick}
		dataCy={`${dataCy}-label-description`}
		component="div"
		variant="body2"
		class={twMerge('text-gray-500', classes.description)}
	>
		{@render description?.()}
	</Txt>
{/if}
